export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";